module.exports = __webpack_public_path__ + "img/orange_047.276a7f7e.png";